class PromotionCampaignSearchController extends BaseSearchController
	@register()
	@inject 'PromotionCampaignService',
		'parseBool'
		'promotionTypeIsCampaign'

	onAdvancedSearchChange: ->
		@setFiltersValidity()

		super()

	setAdvancedSearch: ->
		for labelKey, label of @getPromotionLabelList()
			@searchData.advanced.configuration[labelKey] = label

		super()

		@promotionLabels = @searchData.advanced.configuration[0].filters

	getSearchQuery: ->
		query = @PromotionCampaignService.getQuery(@promotionTypeIsCampaign)

		@addQueryActiveFilter(query)
		@addQueryDateFilter(query)

		return query

	addQueryActiveFilter: (query) ->
		active = @promotionLabels.active.value
		inactive = @promotionLabels.inactive.value

		if active && inactive
			return

		query.criteria('enabled', '=', active)

	addQueryDateFilter: (query) ->
		upcoming = @promotionLabels.upcoming.value
		current = @promotionLabels.current.value
		completed = @promotionLabels.completed.value

		currentTimestamp = moment().unix()

		switch (true)
			when upcoming && current && completed
				return
			when upcoming && current
				dateToCriteria = query.criteria('date_to', '>=', currentTimestamp)
				dateToCriteria.or('date_to', 'IS', 'NULL')
			when current && completed
				query.criteria('date_from', '<=', currentTimestamp)
			when upcoming && completed
				criteria = query.criteria('date_from', '>=', currentTimestamp)
				criteria.or('date_to', '<=', currentTimestamp)
			when upcoming
				query.criteria('date_from', '>=', currentTimestamp)
			when completed
				query.criteria('date_to', '<=', currentTimestamp)
			when current
				query.criteria('date_from', '<=', currentTimestamp)
				dateToCriteria = query.criteria('date_to', '>=', currentTimestamp)
				dateToCriteria.or('date_to', 'IS', 'NULL')

	getPromotionLabelList: ->
		return {
			upcoming:
				value: true
				label: 'wbo.promotion.search.label.upcoming'
				type: 'boolean'
				options:
					style: 'info'
					skip_query: true
			current:
				value: true
				label: 'wbo.promotion.search.label.current'
				type: 'boolean'
				options:
					style: 'success'
					skip_query: true
			completed:
				value: false
				label: 'wbo.promotion.search.label.completed'
				type: 'boolean'
				options:
					style: 'warning'
					skip_query: true
			active:
				value: true
				label: 'general.active'
				type: 'boolean'
				options:
					skip_query: true
			inactive:
				value: true
				label: 'general.inactive'
				type: 'boolean'
				options:
					skip_query: true
		}

	search: (isManualSubmit = false, appendResult = true) ->
		@setFiltersValidity()

		if @searchData.advanced.valid
			super(isManualSubmit, appendResult)

	setFiltersValidity: ->
		if !@advancedSearchEnabled
			return

		dateLabelsValid = @promotionLabels.upcoming.value ||
			@promotionLabels.current.value ||
			@promotionLabels.completed.value

		activeLabelsValid = @promotionLabels.active.value ||
			@promotionLabels.inactive.value

		@searchData.advanced.valid = dateLabelsValid && activeLabelsValid

	getLabelForPromotion: (promotion) ->
		promotionLabels = @getPromotionLabelList()
		currentTimestamp = moment().unix()

		if +promotion.date_from > currentTimestamp
			return promotionLabels.upcoming

		if promotion.date_to && +promotion.date_to < currentTimestamp
			return promotionLabels.completed

		return promotionLabels.current
